var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bindElement)?_c('img',_vm._b({staticStyle:{"display":"inline-block"}},'img',{ id: _vm.uuid },false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }